import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";

import { LanguageProvider } from "@/lib/i18n";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import Showcase from "@/components/Showcase";
import MenuSection from "@/components/MenuSection";
import Vibe from "@/components/Vibe";
import FindUs from "@/components/FindUs";
import Footer from "@/components/Footer";
import LinksPage from "@/components/LinksPage";
import { Toaster } from "@/components/ui/sonner";

const Home = () => {
  return (
    <SmoothScroll>
      <Helmet>
        <title>Monsieur Toast — French Toasted Sandwiches</title>
        <meta
          name="description"
          content="Monsieur Toast — French Toasted Sandwiches. Hand-crafted, served warm. Life is better toasted."
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Monsieur Toast — French Toasted Sandwiches" />
        <meta
          property="og:description"
          content="Hand-crafted French toasted sandwiches, served warm. Life is better toasted."
        />
        <meta property="og:url" content="https://monsieurtoast.com" />
        <meta property="og:image" content="https://monsieurtoast.com/feature-toast.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://monsieurtoast.com" />
      </Helmet>
      <div className="grain" />
      <Header />
      <main data-testid="main-content" className="bg-black text-white">
        <Hero />
        <Story />
        <Showcase />
        <MenuSection />
        <Vibe />
        <FindUs />
      </main>
      <Footer />
    </SmoothScroll>
  );
};

function App() {
  return (
    <div className="App bg-black text-white">
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/links" element={<LinksPage />} />
            </Routes>
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
}

export default App;
